import React, { useState } from "react";

function Note({ note, deleteNote, editNote, togglePin }) {
  const [isEditing, setIsEditing] = useState(false);
  const [newText, setNewText] = useState(note.text);

  return (
    <div className="note">
      {note.pinned && <span className="pin">📌 Pinned</span>}

      {isEditing ? (
        <>
          <input
            value={newText}
            onChange={(e) => setNewText(e.target.value)}
          />
          <button
            onClick={() => {
              editNote(note.id, newText);
              setIsEditing(false);
            }}
          >
            Save
          </button>
        </>
      ) : (
        <>
          <p>{note.text}</p>

          <div className="actions">
            <button onClick={() => setIsEditing(true)}>✏️</button>
            <button onClick={() => deleteNote(note.id)}>🗑️</button>
            <button onClick={() => togglePin(note.id)}>
              {note.pinned ? "❌" : "📌"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default Note;